/* tfm-adv page behaviour (replicates the source's inline scripts without jQuery):
   1. the "UPDATE: As of <date>" line shows today's date;
   2. the mobile CTA row becomes fixed to the bottom after 38% of the page has been scrolled. */
(function () {
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function today() { var d = new Date(); return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  function stampDate() {
    var el = document.getElementById('iqxz8o');
    if (!el) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (/As of [A-Za-z]{3,9} \d{1,2}, \d{4}/.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/As of [A-Za-z]{3,9} \d{1,2}, \d{4}/, 'As of ' + today());
      }
    }
  }
  var rowId = 'r-1662158704571', threshold = 0.38, originalStyle = null, isFixed = false;
  function updatePosition() {
    var el = document.getElementById(rowId);
    if (!el) return;
    if (originalStyle === null) {
      originalStyle = el.getAttribute('style') || '';
      el.setAttribute('style', originalStyle.replace(/position\s*:\s*fixed\s*!?important;?/i, ''));
    }
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollTop = window.scrollY || window.pageYOffset || 0;
    var progress = docHeight > 0 ? scrollTop / docHeight : 0;
    if (progress >= threshold && !isFixed) {
      el.setAttribute('style', originalStyle + '; position: fixed !important; left: 0; right: 0; bottom: 0; z-index: 9999;');
      isFixed = true;
    } else if (progress < threshold && isFixed) {
      el.setAttribute('style', originalStyle);
      isFixed = false;
    }
  }
  function init() {
    stampDate();
    updatePosition();
    window.addEventListener('scroll', updatePosition, { passive: true });
    window.addEventListener('resize', updatePosition);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
